import { render } from "./DiarioAcumulado.vue?vue&type=template&id=246008c7"
import script from "./DiarioAcumulado.vue?vue&type=script&lang=js"
export * from "./DiarioAcumulado.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__